<template lang="pug">
.m-card-body(:id="'match-' + source.id")
  .m-card-item.layout2.openMatchdetail(:class="source.marketId == 3 ? 'live' : ''")
    //- small {{ source.mmoDetails }}
    .m-card-wrap
      .m-card-match-wrapper
        .m-card-match
          TimePanel(:source="source")
          .team-group
            .team(:class="source.details['team'] == 1 ? 'team-red' : ''")
              .team-name {{ source.homeTeam }}
              .red-card(v-if="source.matchBody[24] > 0 && source.matchBody[4] == 3")
                img.img-fluid(:src="'/images/red-card/red-card_' + source.matchBody[24] + '.svg?v=12'" alt='')
            .team(:class="source.details['team'] == 0 ? 'team-red' : ''")
              .team-name {{ source.awayTeam }}
              .red-card(v-if="source.matchBody[25] > 0 && source.matchBody[4] == 3")
                img.img-fluid(:src="'/images/red-card/red-card_' + source.matchBody[25] + '.svg?v=12'" alt='')
          span.custom-tooltip-trigger(
            v-if="source.leagueInfo && source.leagueInfo.length > 0"
            tabindex='0' 
            data-bs-toggle='tooltip' 
            data-bs-placement='top' 
            data-bs-custom-class='my-brand-tooltip' 
            :data-bs-title="source.leagueInfo"
          )
            i.fas.fa-info-circle
        .function-bar
          .icon-btn(@click="xSetFav($event)" :class="xIsFav() == true ? 'active' : ''")
            i.fa-solid.fa-star
          template(v-if="source && source.betTypeId != 'parlay'")
            .icon-btn(v-if="source.stats" @click="xLinkStats(source)")
              i.fa-solid.fa-chart-bar
            .icon-btn(v-if="source.marketId == 3 && source.channelId" @click="handleMore(source, 0)")
              i.fa-solid.fa-tv
          //- .icon-btn(v-if="source.isTimeMachine" @click="showTimeMachine(source)")
          //-   i.fa-solid.fa-clock-rotate-left
        template(v-if="mmoMode && menu3 != 'parlay' && hasMmoDetails")
          .toggle-m-btn.mmo.mt-1(v-if="source.betTypeId == 'hdpou' && [1].includes(source.sportsId) && source.hasOwnProperty('mmoDetails')" @click="toggleMMO") {{ mmoOdds ? $t("ui.asia_hdp") : $t("ui.mmo") }}
      .m-card-odds.matchDetail.collapse
        MatchHDPOU1X2Odds(
          v-if="source.betTypeId == 'hdpou' && [1, 23, 26, 27].includes(source.sportsId) && source.hasOwnProperty('details')"
          v-show="!isMoreMarketCollapseShown"
          :index="index"
          :source="source"
          :mmoOdds="mmoOdds"
          @toggle-more-markets="toggleMoreMarkets"
        )
        .more-market-collapse.collapse(ref="moreMarketCollapse")
          .more-market-tab-nav
            .tab-item(v-for="t in tabDisplay" v-if="!t.isHidden"  :class="{'active': currentTab === t.tabKey}" @click="currentTab = t.tabKey") {{ $tc(t.label, 2) }}
            
          template(v-for="t in tabDisplay" )
            .odds-wrapper(v-show="!t.isHidden" v-if="t.tabKey === MMARKET_HDPF && t.tabKey === currentTab")
              MoreMatchHDPF(
                :source="source"
                :mmoOdds="mmoOdds")
            .odds-wrapper(v-show="!t.isHidden" v-if="t.tabKey === MMARKET_OUF && t.tabKey === currentTab")
              MoreMatchOUF(
                :source="source"
                :mmoOdds="mmoOdds")
            .odds-wrapper(v-show="!t.isHidden" v-if="t.tabKey === MMARKET_HDPH && t.tabKey === currentTab")
              MoreMatchHDPH(
                :source="source"
                :mmoOdds="mmoOdds")
            .odds-wrapper(v-show="!t.isHidden" v-if="t.tabKey === MMARKET_OUH && t.tabKey === currentTab")
              MoreMatchOUH(
                :source="source"
                :mmoOdds="mmoOdds")
          button.close-more-market-btn(type='button' @click="closeMoreMarkets") Close
        MatchHDPOUOEOdds(
          v-if="source.betTypeId == 'hdpou' && [2].includes(source.sportsId) && source.hasOwnProperty('details')"
          :index="index"
          :source="source"
        )
        MatchHDPOUMLOdds(
          v-if="source.betTypeId == 'hdpou' && ![1, 2, 23, 26, 27].includes(source.sportsId) && !vg1.includes(source.sportsId) && source.hasOwnProperty('details')"
          :index="index"
          :source="source"
        )
      .right-wrapper
        .arrow.closeMatchdetail
        .more-btn(v-if="source.details.more > 0" @click="handleMore(source)") {{ source.details.more }}

//- .collapse(
//-   v-if="$store.getters.selectedMatch ? $store.getters.selectedMatch == source.matchId && source.ptype == 30 : source.ptype == 30"
//-   :id="'league-' + source.leagueId"
//-   :aria-labelledby="source.id"
//-   :class="[0,1,2,3,4,5,6].includes($dayjs().day()) && ['today','parlay'].includes(menu1) || [0,1,2,3,4,5,6].includes($dayjs().day()) && ['early'].includes(menu1) && ['parlay'].includes(menu3) || ['0','1','2','3','4','5','6'].includes(selectedDays) && ['early'].includes(menu1) || ['event'].includes(menu0) && ['early'].includes(menu1) ? '' : 'show'"
//- )
//-   .card-body.p-0
//-     .match(:class="(source.marketId == 3) ? 'live' : [41, 42, 43, 44, 47].includes(source.sportsId) ? 'live' : ''")
//-       .match-info(v-if="![40].includes(source.sportsId)")
//-         .d-flex.match-info-team
//-           .match-info-home-name(:class="source.details['team'] == 1 ? 'team-red' : 'team-black'")
//-             .foul-card(v-if="source.matchBody[24] > 0 && source.matchBody[4] == 3")
//-               img(:src="'/images/red-card/red-card_' + source.matchBody[24] + '.svg?v=12'")
//-             .name {{ source.homeTeam }}
//-           TimePanel(:source="source")
//-           .match-info-away-name(:class="source.details['team'] == 0 ? 'team-red' : 'team-black'")
//-             .name {{ source.awayTeam }}
//-             .foul-card(v-if="source.matchBody[25] > 0 && source.matchBody[4] == 3")
//-               img(:src="'/images/red-card/red-card_' + source.matchBody[25] + '.svg?v=12'")
//-       .match-mainmarket.mmo(v-if="mmoMode && menu3 != 'parlay'")
//-         MatchHDPOUMMOOdds(
//-           v-if="source.betTypeId == 'hdpou' && [1].includes(source.sportsId) && source.hasOwnProperty('details')"
//-           :index="index"
//-           :source="source"
//-         )
//-       .match-mainmarket
//-         MatchHDPOU1X2Odds(
//-           v-if="source.betTypeId == 'hdpou' && [1, 23, 26, 27].includes(source.sportsId) && source.hasOwnProperty('details')"
//-           :index="index"
//-           :source="source"
//-         )
//-         //- MatchHDPOU1X2FTOdds(
//-         //-   v-if="source.betTypeId == 'hdpou' && [12].includes(source.sportsId) && source.hasOwnProperty('details')"
//-         //-   :index="index"
//-         //-   :source="source"
//-         //- )
//-         MatchHDPOUMLFTOdds(
//-           v-if="source.betTypeId == 'hdpou' && [41, 42, 43, 44, 47].includes(source.sportsId) && source.hasOwnProperty('details')"
//-           :index="index"
//-           :source="source"
//-         )
//-         MatchHDPOUOEOdds(
//-           v-if="source.betTypeId == 'hdpou' && [2].includes(source.sportsId) && source.hasOwnProperty('details')"
//-           :index="index"
//-           :source="source"
//-         )
//-         MatchHDPOUMLOdds(
//-           v-if="source.betTypeId == 'hdpou' && ![1, 2, 23, 26, 27, 41, 42, 43, 44, 47].includes(source.sportsId) && source.hasOwnProperty('details')"
//-           :index="index"
//-           :source="source"
//-         )
//-         MatchHDPOUMAINOdds(
//-           v-if="source.betTypeId == 'hdpou' && [3].includes(source.marketId) && [20, 41, 42, 47].includes(source.sportsId) && source.hasOwnProperty('details')"
//-           :index="index"
//-           :source="source"
//-         )
//-       //- small {{ source }}
//-       .d-flex.justify-content-between.match-function
//-         .d-flex
//-           .mr-2.icon-function.bg-star(@click="xSetFav($event)" :class="xIsFav() == true ? 'active' : ''")
//-           .mr-2.icon-function(v-if="source && source.betTypeId != 'parlay'")
//-             template(v-if="isEFight(source)")
//-               template(v-if="countDown > 0")
//-                 small {{ countDown }}s
//-               template(v-else)
//-                 template(v-if="source.channelId")
//-                   img(:src="(source.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'" @click="handleMore(source, 0)")
//-                 template(v-else)
//-                   template(v-if="source.channelId >= 1")
//-                     img(:src="(source.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'")
//-             template(v-else)
//-               template(v-if="source.channelId")
//-                 img(:src="(source.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'" @click="handleMore(source, 0)")
//-               template(v-else)
//-                 template(v-if="source.channelId >= 1")
//-                   img(:src="(source.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'")
//-           .mr-2.icon-function.flex-grow-1
//-             template(v-if="source.stats")
//-               img(:src="(source.marketId == 3) ? '/images/statistics-live.svg?v=12' : '/images/statistics.svg?v=12'" @click="xLinkStats(source)")
//-         .mr-0.more(v-if="source.details.more > 0")
//-           a.text-dark(href='javascript:void(0);' @click="handleMore(source)")
//-             | {{ $t("ui.more_markets") }} 
//-             span.more-number {{ source.details.more }}
//-             i.fas.fa-chevron-right.ml-2
//- </template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";
import mixinTypes from "@/library/mixinTypes";
import TimePanel from "@/components/mobile/main/timePanel";
import MatchHDPOUOEOdds from "@/components/mobile/main/xmatch/new/matchHDPOUOEOdds";
import MatchHDPOUMLOdds from "@/components/mobile/main/xmatch/new/matchHDPOUMLOdds";
import MatchHDPOUMLFTOdds from "@/components/mobile/main/xmatch/matchHDPOUMLFTOdds";
import MatchHDPOU1X2Odds from "@/components/mobile/main/xmatch/new/matchHDPOU1X2Odds";
import MatchHDPOU1X2FTOdds from "@/components/mobile/main/xmatch/matchHDPOU1X2FTOdds";
import MatchHDPOUMAINOdds from "@/components/mobile/main/xmatch/matchHDPOUMAINOdds";

import MatchHDPOUMMOOdds from "@/components/mobile/main/xmatch/new/matchHDPOUMMOOdds";
import MoreMatchHDPF from "@/components/mobile/main/more/moreHDPF";
import MoreMatchOUF from "@/components/mobile/main/more/moreOUF";
import MoreMatchHDPH from "@/components/mobile/main/more/moreHDPH";
import MoreMatchOUH from "@/components/mobile/main/more/moreOUH";

export default {
  components: {
    TimePanel,
    MatchHDPOUOEOdds,
    MatchHDPOUMLOdds,
    MatchHDPOUMLFTOdds,
    MatchHDPOU1X2Odds,
    MatchHDPOU1X2FTOdds,
    MatchHDPOUMAINOdds,
    MatchHDPOUMMOOdds,

    MoreMatchHDPF,
    MoreMatchOUF,
    MoreMatchHDPH,
    MoreMatchOUH
  },
  mixins: [mixinTypes],
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object
    }
  },
  data() {
    return {
      fav: false,
      countDown: 0,
      ticker: null,
      isMoreMarketCollapseShown: false,
      mmoOdds: false,
      currentTab: 0,
      tabDisplay: [
        {
          tabKey: 0,
          isHidden: false,
          label: "m.BT_HDPF",
          typeName: "hdp",
          homeIndex: 10,
          awayIndex: 9
        },
        {
          tabKey: 1,
          isHidden: true,
          label: "m.BT_OUF",
          typeName: "ou",
          homeIndex: 12,
          awayIndex: 11
        },
        {
          tabKey: 2,
          isHidden: true,
          label: "m.BT_HDPH",
          typeName: "hdph",
          homeIndex: 10,
          awayIndex: 9
        },
        {
          tabKey: 3,
          isHidden: true,
          label: "m.BT_OUH",
          typeName: "ouh",
          homeIndex: 12,
          awayIndex: 11
        }
      ]
    };
  },
  computed: {
    vg1() {
      return config.vg1;
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    hasMmoDetails() {
      const details = this.source && this.source.mmoDetails;
      if (!details) {
        return false;
      }
      if (Array.isArray(details)) {
        return details.length > 0;
      }
      if (typeof details === "object") {
        return Object.keys(details).length > 0;
      }
      return true;
    },
    MMARKET_HDPF() {
      return 0;
    },
    MMARKET_OUF() {
      return 1;
    },
    MMARKET_HDPH() {
      return 2;
    },
    MMARKET_OUH() {
      return 3;
    }
  },
  watch: {
    tabDisplay(newVal) {
      const needRepointTab = newVal.find(x => x.tabKey == this.currentTab && !!x.isHidden);
      if (!!needRepointTab) this.currentTab = this.MMARKET_HDPF;
    },
    "source.details"(newVal) {
      if (!!newVal && !this.mmoOdds) {
        this.tabDisplay = this.tabDisplay.map(x => {
          const { typeName, homeIndex, awayIndex } = x;
          const sourceCount = !!newVal[typeName] ? newVal[typeName].length : 0;
          const result = sourceCount > 0 && !!newVal && !!newVal[typeName] && !!newVal[typeName][0][homeIndex] && !!newVal[typeName][0][awayIndex];
          return { ...x, isHidden: !result };
        });
      }
    },
    "source.mmoDetails"(newVal) {
      if (!!newVal && !!this.mmoOdds) {
        this.tabDisplay = this.tabDisplay.map(x => {
          const { typeName, homeIndex, awayIndex } = x;
          const sourceCount = !!newVal[typeName] ? newVal[typeName].length : 0;
          const result = sourceCount > 0 && !!newVal && !!newVal[typeName] && !!newVal[typeName][0][homeIndex] && !!newVal[typeName][0][awayIndex];
          return { ...x, isHidden: !result };
        });
      }
    }
  },
  destroyed() {
    if (this.ticker) {
      clearTimeout(this.ticker);
    }
  },
  mounted() {
    if (this.favorite) {
      var isAll = true;
      var items = this.source.matches;
      for (var n in items) {
        if (this.favorite.indexOf(items[n][2]) == -1) {
          isAll = false;
        }
      }
      this.fav = isAll;
    }

    // if (this.source) {
    //   if (this.isEFight(this.source) && (this.source.marketId == 3)) {
    //     this.getCountDown();
    //   }
    // }

    if (this.menu0 == "favorite") {
      this.fav = true;
    }

    this.$nextTick(() => {
      var firstLeague = $(".main-item div:first");
      var childLeague = $(firstLeague).attr("data-target");

      // console.log($(childLeague + ".collapse"));
      if (firstLeague.hasClass("collapsed")) {
        firstLeague.addClass("collapsed").attr("aria-expanded", "false");
        setTimeout(() => {
          $(childLeague + ".collapse").removeClass("show");
        }, 100);
      } else {
        firstLeague.removeClass("collapsed").attr("aria-expanded", "true");
        setTimeout(() => {
          $(childLeague + ".collapse").addClass("show");
        }, 100);
      }
    });
  },
  methods: {
    // isEFight(e) {
    //   if (e && e.sportsId) return config.vg1.includes(e.sportsId);
    //   else return false;
    // },
    // getCountDown() {
    //   this.ticker = setTimeout(() => {
    //     this.countDown = this.$dayjs(this.source.matchTime).add(10, "s").diff(this.$dayjs(), "s");
    //     if (this.countDown >= 0) {
    //       this.getCountDown();
    //     }
    //   }, 1000);
    // },
    handleMore(source, e) {
      this.$store.dispatch("layout/setSelectedMatch", source.matchId);
      this.$store.dispatch("layout/setRadarId", source.radarId);
      this.$store.dispatch("layout/setChannelId", source.channelId);
      EventBus.$emit("GET_MATCH2");
      if (e >= 0) {
        this.$router.push({ name: "more", params: { mode: e } }).catch(err => {});
      } else {
        this.$router.push("/more").catch(err => {});
      }
    },
    showTimeMachine(source) {
      this.$store.dispatch("layout/setShowTimeMachine", true);
      // console.log("hhhhhhhhh", source);
      EventBus.$emit("GET_TM", source);
    },
    xIsFav() {
      if (this.favorite) {
        if (this.favorite.indexOf(this.source.matchId) != -1) {
          return true;
        }
      }
      return false;
    },
    xSetFav(evt) {
      var favList = [];
      if (favList.indexOf(this.source.matchId) == -1) {
        favList.push(this.source.matchId);
      }
      if (this.xIsFav(this.source.matchId)) {
        this.$store.dispatch("layout/delFavorite", favList);
      } else {
        this.$store.dispatch("layout/setFavorite", favList);
      }
      if (this.menu0 == "favorite") {
        setTimeout(() => {
          EventBus.$emit("GET_MARKET");
        }, 500);
      }
    },
    xLinkStats(e) {
      if (e && e.stats) {
        var url = config.statscenterUrl() + e.stats + "&u=" + this.$store.getters.accountId + "&t=" + this.$store.getters.sessionToken + "&l=" + this.$store.getters.language;
        window.open(url, "_blank", "stats", "top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no");
      }
    },
    toggleMoreMarkets() {
      this.$nextTick(() => {
        const collapseEl = this.$refs.moreMarketCollapse;
        let dataDet;
        if (this.mmoOdds) dataDet = this.source["mmoDetails"];
        else dataDet = this.source["details"];

        if (collapseEl) {
          const matchDetailEl = this.$el.querySelector(".matchDetail");
          const oddsSwiper = matchDetailEl ? matchDetailEl.querySelector("swiper, .swiper") : null;

          if (collapseEl.style.display === "block" || collapseEl.classList.contains("show") || (!!dataDet["hdp"] && dataDet["hdp"].length <= 1)) {
            collapseEl.style.display = "none";
            collapseEl.classList.remove("show");
            this.isMoreMarketCollapseShown = false;
            if (oddsSwiper) {
              oddsSwiper.style.display = "";
            }
          } else {
            collapseEl.style.display = "block";
            collapseEl.classList.add("show");
            this.isMoreMarketCollapseShown = true;
            if (oddsSwiper) {
              oddsSwiper.style.display = "none";
            }
          }
        }
      });
    },
    closeMoreMarkets() {
      this.currentTab = 0;
      this.$nextTick(() => {
        const collapseEl = this.$refs.moreMarketCollapse;
        if (collapseEl) {
          const matchDetailEl = this.$el.querySelector(".matchDetail");
          const oddsSwiper = matchDetailEl ? matchDetailEl.querySelector("swiper, .swiper") : null;

          collapseEl.style.display = "none";
          collapseEl.classList.remove("show");
          this.isMoreMarketCollapseShown = false;
          if (oddsSwiper) {
            oddsSwiper.style.display = "";
          }
        }
      });
    },
    toggleMMO() {
      this.mmoOdds = !this.mmoOdds;
    }
  }
};
</script>
